/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdvancedSearchPromptOrigin } from './';
import {
    AdvancedSearchPromptOriginFromJSON,
    AdvancedSearchPromptOriginFromJSONTyped,
    AdvancedSearchPromptOriginToJSON,
} from './';
import type { IdentityRef } from './';
import {
    IdentityRefFromJSON,
    IdentityRefFromJSONTyped,
    IdentityRefToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateAdvancedSearchFromPromptRequest
 */
export interface CreateAdvancedSearchFromPromptRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAdvancedSearchFromPromptRequest
     */
    prompt: string;
    /**
     * 
     * @type {IdentityRef}
     * @memberof CreateAdvancedSearchFromPromptRequest
     */
    onBehalfOf?: IdentityRef;
    /**
     * 
     * @type {AdvancedSearchPromptOrigin}
     * @memberof CreateAdvancedSearchFromPromptRequest
     */
    origin?: AdvancedSearchPromptOrigin;
    /**
     * 
     * @type {string}
     * @memberof CreateAdvancedSearchFromPromptRequest
     */
    referralId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAdvancedSearchFromPromptRequest
     */
    submittedWithEnterKey?: boolean;
}

/**
 * Check if a given object implements the CreateAdvancedSearchFromPromptRequest interface.
 */
export function instanceOfCreateAdvancedSearchFromPromptRequest(value: object): value is CreateAdvancedSearchFromPromptRequest {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    return true;
}

export function CreateAdvancedSearchFromPromptRequestFromJSON(json: any): CreateAdvancedSearchFromPromptRequest {
    return CreateAdvancedSearchFromPromptRequestFromJSONTyped(json, false);
}

export function CreateAdvancedSearchFromPromptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAdvancedSearchFromPromptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'onBehalfOf': json['onBehalfOf'] == null ? undefined : IdentityRefFromJSON(json['onBehalfOf']),
        'origin': json['origin'] == null ? undefined : AdvancedSearchPromptOriginFromJSON(json['origin']),
        'referralId': json['referralId'] == null ? undefined : json['referralId'],
        'submittedWithEnterKey': json['submittedWithEnterKey'] == null ? undefined : json['submittedWithEnterKey'],
    };
}

export function CreateAdvancedSearchFromPromptRequestToJSON(value?: CreateAdvancedSearchFromPromptRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'prompt': value['prompt'],
        'onBehalfOf': IdentityRefToJSON(value['onBehalfOf']),
        'origin': AdvancedSearchPromptOriginToJSON(value['origin']),
        'referralId': value['referralId'],
        'submittedWithEnterKey': value['submittedWithEnterKey'],
    };
}

